import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SiteNav } from "@softmax/ide/frontend";
import workspaceStyles from "@softmax/ide/styles.css?url";

export const Route = createFileRoute("/_workspace")({
  head: () => ({
    meta: [
      { title: "Softmax IDE" },
      { name: "robots", content: "noindex, nofollow" },
    ],
    // Explicitly enabled links opt out of React's retained stylesheet cache, so this reset leaves with the route.
    links: [{ rel: "stylesheet", href: workspaceStyles, disabled: false }],
  }),
  component: WorkspaceLayout,
});

function WorkspaceLayout() {
  return (
    <>
      <SiteNav />
      <Outlet />
    </>
  );
}
